// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ACL6","selects":"Documents_selects__kxGpx"};